import Button from './Button';

export { default as Button } from './Button';
export { default as LoadingButton } from './LoadingButton';

export default Button;
